export default __webpack_public_path__ + "static/media/p5.67c39123.jpg";